import { render, staticRenderFns } from "./desktop-a45.vue?vue&type=template&id=1f90e6f8&"
import script from "./desktop-a45.vue?vue&type=script&lang=js&"
export * from "./desktop-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports